import { Component, OnInit } from '@angular/core';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from '../theme-customizer/theme-customizer.service';
import { HttpClientModule } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CategoryNewsService } from 'src/app/services/category-news.service';
import { PublicNewsService } from 'src/app/services/public-news.service';

@Component({
    selector: 'app-hometwo-courses',
    templateUrl: './hometwo-courses.component.html',
})
export class HometwoCoursesComponent implements OnInit {

    isToggled = false;
    categoryNews: any[] = [];
    publicNews: any[] = [];
    currentTab = 'tab1';

    constructor(
        public themeService: ThemeCustomizerService,
        public categoryNewsService: CategoryNewsService,
        public publicNewsService: PublicNewsService
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit(): void {
        this.categoryNewsService.getAll$().subscribe(categories => {
            this.categoryNews = categories;
            this.categoryNews.forEach(category => this.getPublicNews(category.referenceId));
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    switchTab(event: MouseEvent, tab: string) {
        event.preventDefault();
        this.currentTab = tab;
    }

    getPublicNews(categoryId: string) {
        this.publicNewsService.getById$(categoryId).subscribe(news => {
            this.publicNews = news;
        });
    }

    getPublicNewsByCategory(categoryId: string) {
        return this.publicNews?.filter(news => news?.categoryNewsReferenceId === categoryId);
    }

    getNewsCountByCategory(categoryId: string): number {
        return this.publicNews?.filter(news => news?.categoryNewsReferenceId === categoryId).length;
    }
}